/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HealthRouteImport } from './routes/health'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthedUsersRouteImport } from './routes/_authed/users'
import { Route as AuthedTranscodesRouteImport } from './routes/_authed/transcodes'
import { Route as AuthedTmdbRouteImport } from './routes/_authed/tmdb'
import { Route as AuthedSubtitleTranslateRouteImport } from './routes/_authed/subtitle-translate'
import { Route as AuthedStaleAnimesRouteImport } from './routes/_authed/stale-animes'
import { Route as AuthedRssNotificationsRouteImport } from './routes/_authed/rss-notifications'
import { Route as AuthedReportsRouteImport } from './routes/_authed/reports'
import { Route as AuthedReplyTemplatesRouteImport } from './routes/_authed/reply-templates'
import { Route as AuthedProductsRouteImport } from './routes/_authed/products'
import { Route as AuthedProductFeedbackRouteImport } from './routes/_authed/product-feedback'
import { Route as AuthedPaymentReconciliationRouteImport } from './routes/_authed/payment-reconciliation'
import { Route as AuthedOrdersRouteImport } from './routes/_authed/orders'
import { Route as AuthedFriendLinksRouteImport } from './routes/_authed/friend-links'
import { Route as AuthedFeedbackRoutesRouteImport } from './routes/_authed/feedback-routes'
import { Route as AuthedExamContributionsRouteImport } from './routes/_authed/exam-contributions'
import { Route as AuthedEpisodeFeedbackRouteImport } from './routes/_authed/episode-feedback'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedDanmakuRouteImport } from './routes/_authed/danmaku'
import { Route as AuthedCrossMediaRouteImport } from './routes/_authed/cross-media'
import { Route as AuthedCommentsRouteImport } from './routes/_authed/comments'
import { Route as AuthedCacheRouteImport } from './routes/_authed/cache'
import { Route as AuthedBadgesRouteImport } from './routes/_authed/badges'
import { Route as AuthedAuditRouteImport } from './routes/_authed/audit'
import { Route as AuthedAppVersionsRouteImport } from './routes/_authed/app-versions'
import { Route as AuthedAnnouncementsRouteImport } from './routes/_authed/announcements'
import { Route as AuthedAnimeTypesRouteImport } from './routes/_authed/anime-types'
import { Route as AuthedAnimeSeriesRouteImport } from './routes/_authed/anime-series'
import { Route as AuthedAnimeNewRouteImport } from './routes/_authed/anime-new'
import { Route as AuthedAnimeRouteImport } from './routes/_authed/anime'
import { Route as AuthedAndroidAdsRouteImport } from './routes/_authed/android-ads'
import { Route as AuthedAdSlotsRouteImport } from './routes/_authed/ad-slots'
import { Route as AuthedAnimeAnimeIdEpisodesRouteImport } from './routes/_authed/anime_.$animeId.episodes'
import { Route as AuthedAnimeAnimeIdEditRouteImport } from './routes/_authed/anime_.$animeId.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthRoute = HealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTranscodesRoute = AuthedTranscodesRouteImport.update({
  id: '/transcodes',
  path: '/transcodes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTmdbRoute = AuthedTmdbRouteImport.update({
  id: '/tmdb',
  path: '/tmdb',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSubtitleTranslateRoute = AuthedSubtitleTranslateRouteImport.update({
  id: '/subtitle-translate',
  path: '/subtitle-translate',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStaleAnimesRoute = AuthedStaleAnimesRouteImport.update({
  id: '/stale-animes',
  path: '/stale-animes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRssNotificationsRoute = AuthedRssNotificationsRouteImport.update({
  id: '/rss-notifications',
  path: '/rss-notifications',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReplyTemplatesRoute = AuthedReplyTemplatesRouteImport.update({
  id: '/reply-templates',
  path: '/reply-templates',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProductsRoute = AuthedProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProductFeedbackRoute = AuthedProductFeedbackRouteImport.update({
  id: '/product-feedback',
  path: '/product-feedback',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaymentReconciliationRoute =
  AuthedPaymentReconciliationRouteImport.update({
    id: '/payment-reconciliation',
    path: '/payment-reconciliation',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedOrdersRoute = AuthedOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFriendLinksRoute = AuthedFriendLinksRouteImport.update({
  id: '/friend-links',
  path: '/friend-links',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFeedbackRoutesRoute = AuthedFeedbackRoutesRouteImport.update({
  id: '/feedback-routes',
  path: '/feedback-routes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedExamContributionsRoute = AuthedExamContributionsRouteImport.update({
  id: '/exam-contributions',
  path: '/exam-contributions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEpisodeFeedbackRoute = AuthedEpisodeFeedbackRouteImport.update({
  id: '/episode-feedback',
  path: '/episode-feedback',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDanmakuRoute = AuthedDanmakuRouteImport.update({
  id: '/danmaku',
  path: '/danmaku',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCrossMediaRoute = AuthedCrossMediaRouteImport.update({
  id: '/cross-media',
  path: '/cross-media',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommentsRoute = AuthedCommentsRouteImport.update({
  id: '/comments',
  path: '/comments',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCacheRoute = AuthedCacheRouteImport.update({
  id: '/cache',
  path: '/cache',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBadgesRoute = AuthedBadgesRouteImport.update({
  id: '/badges',
  path: '/badges',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditRoute = AuthedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAppVersionsRoute = AuthedAppVersionsRouteImport.update({
  id: '/app-versions',
  path: '/app-versions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnnouncementsRoute = AuthedAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnimeTypesRoute = AuthedAnimeTypesRouteImport.update({
  id: '/anime-types',
  path: '/anime-types',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnimeSeriesRoute = AuthedAnimeSeriesRouteImport.update({
  id: '/anime-series',
  path: '/anime-series',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnimeNewRoute = AuthedAnimeNewRouteImport.update({
  id: '/anime-new',
  path: '/anime-new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnimeRoute = AuthedAnimeRouteImport.update({
  id: '/anime',
  path: '/anime',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAndroidAdsRoute = AuthedAndroidAdsRouteImport.update({
  id: '/android-ads',
  path: '/android-ads',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdSlotsRoute = AuthedAdSlotsRouteImport.update({
  id: '/ad-slots',
  path: '/ad-slots',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnimeAnimeIdEpisodesRoute =
  AuthedAnimeAnimeIdEpisodesRouteImport.update({
    id: '/anime_/$animeId/episodes',
    path: '/anime/$animeId/episodes',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAnimeAnimeIdEditRoute = AuthedAnimeAnimeIdEditRouteImport.update({
  id: '/anime_/$animeId/edit',
  path: '/anime/$animeId/edit',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/ad-slots': typeof AuthedAdSlotsRoute
  '/android-ads': typeof AuthedAndroidAdsRoute
  '/anime': typeof AuthedAnimeRoute
  '/anime-new': typeof AuthedAnimeNewRoute
  '/anime-series': typeof AuthedAnimeSeriesRoute
  '/anime-types': typeof AuthedAnimeTypesRoute
  '/announcements': typeof AuthedAnnouncementsRoute
  '/app-versions': typeof AuthedAppVersionsRoute
  '/audit': typeof AuthedAuditRoute
  '/badges': typeof AuthedBadgesRoute
  '/cache': typeof AuthedCacheRoute
  '/comments': typeof AuthedCommentsRoute
  '/cross-media': typeof AuthedCrossMediaRoute
  '/danmaku': typeof AuthedDanmakuRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/episode-feedback': typeof AuthedEpisodeFeedbackRoute
  '/exam-contributions': typeof AuthedExamContributionsRoute
  '/feedback-routes': typeof AuthedFeedbackRoutesRoute
  '/friend-links': typeof AuthedFriendLinksRoute
  '/orders': typeof AuthedOrdersRoute
  '/payment-reconciliation': typeof AuthedPaymentReconciliationRoute
  '/product-feedback': typeof AuthedProductFeedbackRoute
  '/products': typeof AuthedProductsRoute
  '/reply-templates': typeof AuthedReplyTemplatesRoute
  '/reports': typeof AuthedReportsRoute
  '/rss-notifications': typeof AuthedRssNotificationsRoute
  '/stale-animes': typeof AuthedStaleAnimesRoute
  '/subtitle-translate': typeof AuthedSubtitleTranslateRoute
  '/tmdb': typeof AuthedTmdbRoute
  '/transcodes': typeof AuthedTranscodesRoute
  '/users': typeof AuthedUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/anime/$animeId/edit': typeof AuthedAnimeAnimeIdEditRoute
  '/anime/$animeId/episodes': typeof AuthedAnimeAnimeIdEpisodesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/ad-slots': typeof AuthedAdSlotsRoute
  '/android-ads': typeof AuthedAndroidAdsRoute
  '/anime': typeof AuthedAnimeRoute
  '/anime-new': typeof AuthedAnimeNewRoute
  '/anime-series': typeof AuthedAnimeSeriesRoute
  '/anime-types': typeof AuthedAnimeTypesRoute
  '/announcements': typeof AuthedAnnouncementsRoute
  '/app-versions': typeof AuthedAppVersionsRoute
  '/audit': typeof AuthedAuditRoute
  '/badges': typeof AuthedBadgesRoute
  '/cache': typeof AuthedCacheRoute
  '/comments': typeof AuthedCommentsRoute
  '/cross-media': typeof AuthedCrossMediaRoute
  '/danmaku': typeof AuthedDanmakuRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/episode-feedback': typeof AuthedEpisodeFeedbackRoute
  '/exam-contributions': typeof AuthedExamContributionsRoute
  '/feedback-routes': typeof AuthedFeedbackRoutesRoute
  '/friend-links': typeof AuthedFriendLinksRoute
  '/orders': typeof AuthedOrdersRoute
  '/payment-reconciliation': typeof AuthedPaymentReconciliationRoute
  '/product-feedback': typeof AuthedProductFeedbackRoute
  '/products': typeof AuthedProductsRoute
  '/reply-templates': typeof AuthedReplyTemplatesRoute
  '/reports': typeof AuthedReportsRoute
  '/rss-notifications': typeof AuthedRssNotificationsRoute
  '/stale-animes': typeof AuthedStaleAnimesRoute
  '/subtitle-translate': typeof AuthedSubtitleTranslateRoute
  '/tmdb': typeof AuthedTmdbRoute
  '/transcodes': typeof AuthedTranscodesRoute
  '/users': typeof AuthedUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/anime/$animeId/edit': typeof AuthedAnimeAnimeIdEditRoute
  '/anime/$animeId/episodes': typeof AuthedAnimeAnimeIdEpisodesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/_authed/ad-slots': typeof AuthedAdSlotsRoute
  '/_authed/android-ads': typeof AuthedAndroidAdsRoute
  '/_authed/anime': typeof AuthedAnimeRoute
  '/_authed/anime-new': typeof AuthedAnimeNewRoute
  '/_authed/anime-series': typeof AuthedAnimeSeriesRoute
  '/_authed/anime-types': typeof AuthedAnimeTypesRoute
  '/_authed/announcements': typeof AuthedAnnouncementsRoute
  '/_authed/app-versions': typeof AuthedAppVersionsRoute
  '/_authed/audit': typeof AuthedAuditRoute
  '/_authed/badges': typeof AuthedBadgesRoute
  '/_authed/cache': typeof AuthedCacheRoute
  '/_authed/comments': typeof AuthedCommentsRoute
  '/_authed/cross-media': typeof AuthedCrossMediaRoute
  '/_authed/danmaku': typeof AuthedDanmakuRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/episode-feedback': typeof AuthedEpisodeFeedbackRoute
  '/_authed/exam-contributions': typeof AuthedExamContributionsRoute
  '/_authed/feedback-routes': typeof AuthedFeedbackRoutesRoute
  '/_authed/friend-links': typeof AuthedFriendLinksRoute
  '/_authed/orders': typeof AuthedOrdersRoute
  '/_authed/payment-reconciliation': typeof AuthedPaymentReconciliationRoute
  '/_authed/product-feedback': typeof AuthedProductFeedbackRoute
  '/_authed/products': typeof AuthedProductsRoute
  '/_authed/reply-templates': typeof AuthedReplyTemplatesRoute
  '/_authed/reports': typeof AuthedReportsRoute
  '/_authed/rss-notifications': typeof AuthedRssNotificationsRoute
  '/_authed/stale-animes': typeof AuthedStaleAnimesRoute
  '/_authed/subtitle-translate': typeof AuthedSubtitleTranslateRoute
  '/_authed/tmdb': typeof AuthedTmdbRoute
  '/_authed/transcodes': typeof AuthedTranscodesRoute
  '/_authed/users': typeof AuthedUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_authed/anime_/$animeId/edit': typeof AuthedAnimeAnimeIdEditRoute
  '/_authed/anime_/$animeId/episodes': typeof AuthedAnimeAnimeIdEpisodesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/health'
    | '/login'
    | '/ad-slots'
    | '/android-ads'
    | '/anime'
    | '/anime-new'
    | '/anime-series'
    | '/anime-types'
    | '/announcements'
    | '/app-versions'
    | '/audit'
    | '/badges'
    | '/cache'
    | '/comments'
    | '/cross-media'
    | '/danmaku'
    | '/dashboard'
    | '/episode-feedback'
    | '/exam-contributions'
    | '/feedback-routes'
    | '/friend-links'
    | '/orders'
    | '/payment-reconciliation'
    | '/product-feedback'
    | '/products'
    | '/reply-templates'
    | '/reports'
    | '/rss-notifications'
    | '/stale-animes'
    | '/subtitle-translate'
    | '/tmdb'
    | '/transcodes'
    | '/users'
    | '/auth/callback'
    | '/anime/$animeId/edit'
    | '/anime/$animeId/episodes'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/health'
    | '/login'
    | '/ad-slots'
    | '/android-ads'
    | '/anime'
    | '/anime-new'
    | '/anime-series'
    | '/anime-types'
    | '/announcements'
    | '/app-versions'
    | '/audit'
    | '/badges'
    | '/cache'
    | '/comments'
    | '/cross-media'
    | '/danmaku'
    | '/dashboard'
    | '/episode-feedback'
    | '/exam-contributions'
    | '/feedback-routes'
    | '/friend-links'
    | '/orders'
    | '/payment-reconciliation'
    | '/product-feedback'
    | '/products'
    | '/reply-templates'
    | '/reports'
    | '/rss-notifications'
    | '/stale-animes'
    | '/subtitle-translate'
    | '/tmdb'
    | '/transcodes'
    | '/users'
    | '/auth/callback'
    | '/anime/$animeId/edit'
    | '/anime/$animeId/episodes'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/health'
    | '/login'
    | '/_authed/ad-slots'
    | '/_authed/android-ads'
    | '/_authed/anime'
    | '/_authed/anime-new'
    | '/_authed/anime-series'
    | '/_authed/anime-types'
    | '/_authed/announcements'
    | '/_authed/app-versions'
    | '/_authed/audit'
    | '/_authed/badges'
    | '/_authed/cache'
    | '/_authed/comments'
    | '/_authed/cross-media'
    | '/_authed/danmaku'
    | '/_authed/dashboard'
    | '/_authed/episode-feedback'
    | '/_authed/exam-contributions'
    | '/_authed/feedback-routes'
    | '/_authed/friend-links'
    | '/_authed/orders'
    | '/_authed/payment-reconciliation'
    | '/_authed/product-feedback'
    | '/_authed/products'
    | '/_authed/reply-templates'
    | '/_authed/reports'
    | '/_authed/rss-notifications'
    | '/_authed/stale-animes'
    | '/_authed/subtitle-translate'
    | '/_authed/tmdb'
    | '/_authed/transcodes'
    | '/_authed/users'
    | '/auth/callback'
    | '/_authed/anime_/$animeId/edit'
    | '/_authed/anime_/$animeId/episodes'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  HealthRoute: typeof HealthRoute
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health': {
      id: '/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof HealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/transcodes': {
      id: '/_authed/transcodes'
      path: '/transcodes'
      fullPath: '/transcodes'
      preLoaderRoute: typeof AuthedTranscodesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tmdb': {
      id: '/_authed/tmdb'
      path: '/tmdb'
      fullPath: '/tmdb'
      preLoaderRoute: typeof AuthedTmdbRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/subtitle-translate': {
      id: '/_authed/subtitle-translate'
      path: '/subtitle-translate'
      fullPath: '/subtitle-translate'
      preLoaderRoute: typeof AuthedSubtitleTranslateRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/stale-animes': {
      id: '/_authed/stale-animes'
      path: '/stale-animes'
      fullPath: '/stale-animes'
      preLoaderRoute: typeof AuthedStaleAnimesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/rss-notifications': {
      id: '/_authed/rss-notifications'
      path: '/rss-notifications'
      fullPath: '/rss-notifications'
      preLoaderRoute: typeof AuthedRssNotificationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reply-templates': {
      id: '/_authed/reply-templates'
      path: '/reply-templates'
      fullPath: '/reply-templates'
      preLoaderRoute: typeof AuthedReplyTemplatesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/products': {
      id: '/_authed/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthedProductsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/product-feedback': {
      id: '/_authed/product-feedback'
      path: '/product-feedback'
      fullPath: '/product-feedback'
      preLoaderRoute: typeof AuthedProductFeedbackRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payment-reconciliation': {
      id: '/_authed/payment-reconciliation'
      path: '/payment-reconciliation'
      fullPath: '/payment-reconciliation'
      preLoaderRoute: typeof AuthedPaymentReconciliationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/orders': {
      id: '/_authed/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthedOrdersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/friend-links': {
      id: '/_authed/friend-links'
      path: '/friend-links'
      fullPath: '/friend-links'
      preLoaderRoute: typeof AuthedFriendLinksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/feedback-routes': {
      id: '/_authed/feedback-routes'
      path: '/feedback-routes'
      fullPath: '/feedback-routes'
      preLoaderRoute: typeof AuthedFeedbackRoutesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/exam-contributions': {
      id: '/_authed/exam-contributions'
      path: '/exam-contributions'
      fullPath: '/exam-contributions'
      preLoaderRoute: typeof AuthedExamContributionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/episode-feedback': {
      id: '/_authed/episode-feedback'
      path: '/episode-feedback'
      fullPath: '/episode-feedback'
      preLoaderRoute: typeof AuthedEpisodeFeedbackRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/danmaku': {
      id: '/_authed/danmaku'
      path: '/danmaku'
      fullPath: '/danmaku'
      preLoaderRoute: typeof AuthedDanmakuRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cross-media': {
      id: '/_authed/cross-media'
      path: '/cross-media'
      fullPath: '/cross-media'
      preLoaderRoute: typeof AuthedCrossMediaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/comments': {
      id: '/_authed/comments'
      path: '/comments'
      fullPath: '/comments'
      preLoaderRoute: typeof AuthedCommentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cache': {
      id: '/_authed/cache'
      path: '/cache'
      fullPath: '/cache'
      preLoaderRoute: typeof AuthedCacheRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/badges': {
      id: '/_authed/badges'
      path: '/badges'
      fullPath: '/badges'
      preLoaderRoute: typeof AuthedBadgesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit': {
      id: '/_authed/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthedAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/app-versions': {
      id: '/_authed/app-versions'
      path: '/app-versions'
      fullPath: '/app-versions'
      preLoaderRoute: typeof AuthedAppVersionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/announcements': {
      id: '/_authed/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AuthedAnnouncementsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/anime-types': {
      id: '/_authed/anime-types'
      path: '/anime-types'
      fullPath: '/anime-types'
      preLoaderRoute: typeof AuthedAnimeTypesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/anime-series': {
      id: '/_authed/anime-series'
      path: '/anime-series'
      fullPath: '/anime-series'
      preLoaderRoute: typeof AuthedAnimeSeriesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/anime-new': {
      id: '/_authed/anime-new'
      path: '/anime-new'
      fullPath: '/anime-new'
      preLoaderRoute: typeof AuthedAnimeNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/anime': {
      id: '/_authed/anime'
      path: '/anime'
      fullPath: '/anime'
      preLoaderRoute: typeof AuthedAnimeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/android-ads': {
      id: '/_authed/android-ads'
      path: '/android-ads'
      fullPath: '/android-ads'
      preLoaderRoute: typeof AuthedAndroidAdsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ad-slots': {
      id: '/_authed/ad-slots'
      path: '/ad-slots'
      fullPath: '/ad-slots'
      preLoaderRoute: typeof AuthedAdSlotsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/anime_/$animeId/episodes': {
      id: '/_authed/anime_/$animeId/episodes'
      path: '/anime/$animeId/episodes'
      fullPath: '/anime/$animeId/episodes'
      preLoaderRoute: typeof AuthedAnimeAnimeIdEpisodesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/anime_/$animeId/edit': {
      id: '/_authed/anime_/$animeId/edit'
      path: '/anime/$animeId/edit'
      fullPath: '/anime/$animeId/edit'
      preLoaderRoute: typeof AuthedAnimeAnimeIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAdSlotsRoute: typeof AuthedAdSlotsRoute
  AuthedAndroidAdsRoute: typeof AuthedAndroidAdsRoute
  AuthedAnimeRoute: typeof AuthedAnimeRoute
  AuthedAnimeNewRoute: typeof AuthedAnimeNewRoute
  AuthedAnimeSeriesRoute: typeof AuthedAnimeSeriesRoute
  AuthedAnimeTypesRoute: typeof AuthedAnimeTypesRoute
  AuthedAnnouncementsRoute: typeof AuthedAnnouncementsRoute
  AuthedAppVersionsRoute: typeof AuthedAppVersionsRoute
  AuthedAuditRoute: typeof AuthedAuditRoute
  AuthedBadgesRoute: typeof AuthedBadgesRoute
  AuthedCacheRoute: typeof AuthedCacheRoute
  AuthedCommentsRoute: typeof AuthedCommentsRoute
  AuthedCrossMediaRoute: typeof AuthedCrossMediaRoute
  AuthedDanmakuRoute: typeof AuthedDanmakuRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedEpisodeFeedbackRoute: typeof AuthedEpisodeFeedbackRoute
  AuthedExamContributionsRoute: typeof AuthedExamContributionsRoute
  AuthedFeedbackRoutesRoute: typeof AuthedFeedbackRoutesRoute
  AuthedFriendLinksRoute: typeof AuthedFriendLinksRoute
  AuthedOrdersRoute: typeof AuthedOrdersRoute
  AuthedPaymentReconciliationRoute: typeof AuthedPaymentReconciliationRoute
  AuthedProductFeedbackRoute: typeof AuthedProductFeedbackRoute
  AuthedProductsRoute: typeof AuthedProductsRoute
  AuthedReplyTemplatesRoute: typeof AuthedReplyTemplatesRoute
  AuthedReportsRoute: typeof AuthedReportsRoute
  AuthedRssNotificationsRoute: typeof AuthedRssNotificationsRoute
  AuthedStaleAnimesRoute: typeof AuthedStaleAnimesRoute
  AuthedSubtitleTranslateRoute: typeof AuthedSubtitleTranslateRoute
  AuthedTmdbRoute: typeof AuthedTmdbRoute
  AuthedTranscodesRoute: typeof AuthedTranscodesRoute
  AuthedUsersRoute: typeof AuthedUsersRoute
  AuthedAnimeAnimeIdEditRoute: typeof AuthedAnimeAnimeIdEditRoute
  AuthedAnimeAnimeIdEpisodesRoute: typeof AuthedAnimeAnimeIdEpisodesRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdSlotsRoute: AuthedAdSlotsRoute,
  AuthedAndroidAdsRoute: AuthedAndroidAdsRoute,
  AuthedAnimeRoute: AuthedAnimeRoute,
  AuthedAnimeNewRoute: AuthedAnimeNewRoute,
  AuthedAnimeSeriesRoute: AuthedAnimeSeriesRoute,
  AuthedAnimeTypesRoute: AuthedAnimeTypesRoute,
  AuthedAnnouncementsRoute: AuthedAnnouncementsRoute,
  AuthedAppVersionsRoute: AuthedAppVersionsRoute,
  AuthedAuditRoute: AuthedAuditRoute,
  AuthedBadgesRoute: AuthedBadgesRoute,
  AuthedCacheRoute: AuthedCacheRoute,
  AuthedCommentsRoute: AuthedCommentsRoute,
  AuthedCrossMediaRoute: AuthedCrossMediaRoute,
  AuthedDanmakuRoute: AuthedDanmakuRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedEpisodeFeedbackRoute: AuthedEpisodeFeedbackRoute,
  AuthedExamContributionsRoute: AuthedExamContributionsRoute,
  AuthedFeedbackRoutesRoute: AuthedFeedbackRoutesRoute,
  AuthedFriendLinksRoute: AuthedFriendLinksRoute,
  AuthedOrdersRoute: AuthedOrdersRoute,
  AuthedPaymentReconciliationRoute: AuthedPaymentReconciliationRoute,
  AuthedProductFeedbackRoute: AuthedProductFeedbackRoute,
  AuthedProductsRoute: AuthedProductsRoute,
  AuthedReplyTemplatesRoute: AuthedReplyTemplatesRoute,
  AuthedReportsRoute: AuthedReportsRoute,
  AuthedRssNotificationsRoute: AuthedRssNotificationsRoute,
  AuthedStaleAnimesRoute: AuthedStaleAnimesRoute,
  AuthedSubtitleTranslateRoute: AuthedSubtitleTranslateRoute,
  AuthedTmdbRoute: AuthedTmdbRoute,
  AuthedTranscodesRoute: AuthedTranscodesRoute,
  AuthedUsersRoute: AuthedUsersRoute,
  AuthedAnimeAnimeIdEditRoute: AuthedAnimeAnimeIdEditRoute,
  AuthedAnimeAnimeIdEpisodesRoute: AuthedAnimeAnimeIdEpisodesRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  HealthRoute: HealthRoute,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
